export default __webpack_public_path__ + "static/media/ManU-Logo2.0de2dd3a.png";